import { render, staticRenderFns } from "./ShopLabel.vue?vue&type=template&id=30217842&"
import script from "./ShopLabel.vue?vue&type=script&lang=js&"
export * from "./ShopLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopLabel.vue"
export default component.exports